import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Share, Plus } from "lucide-react";

interface PWAInstallDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function PWAInstallDialog({ open, onOpenChange }: PWAInstallDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>App auf iPhone installieren</DialogTitle>
          <DialogDescription>
            Füge D2D+ zu deinem Homescreen hinzu, um die App wie eine native App zu nutzen.
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4 py-4">
          <div className="flex items-start gap-3">
            <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
              <span className="text-sm font-bold">1</span>
            </div>
            <div>
              <p className="font-medium">Teilen-Button antippen</p>
              <p className="text-sm text-muted-foreground">
                Tippe unten in Safari auf das Teilen-Symbol
              </p>
              <div className="mt-2 flex items-center gap-2 text-primary">
                <Share className="h-5 w-5" />
                <span className="text-sm">Teilen</span>
              </div>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
              <span className="text-sm font-bold">2</span>
            </div>
            <div>
              <p className="font-medium">"Zum Home-Bildschirm" wählen</p>
              <p className="text-sm text-muted-foreground">
                Scrolle im Menü nach unten und tippe auf "Zum Home-Bildschirm"
              </p>
              <div className="mt-2 flex items-center gap-2 text-primary">
                <Plus className="h-5 w-5" />
                <span className="text-sm">Zum Home-Bildschirm</span>
              </div>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
              <span className="text-sm font-bold">3</span>
            </div>
            <div>
              <p className="font-medium">"Hinzufügen" bestätigen</p>
              <p className="text-sm text-muted-foreground">
                Tippe oben rechts auf "Hinzufügen" um die App zu installieren
              </p>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
